import React from 'react';
import { Button } from '@material-ui/core';

interface Props {
  onClick: () => void;
}

const CancelButton = ({ onClick }: Props) => (
  <Button onClick={onClick} variant="contained">
    Cancel
  </Button>
);

export default CancelButton;
